import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';

export interface LocationUploadRequirementControlProps {
  name: string;
  id: string;
  disabled: boolean;
}

export function LocationUploadRequirementControl({
  name,
  id,
  disabled,
}: LocationUploadRequirementControlProps): JSX.Element {
  const { control } = useFormContext();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      disabled={disabled}
      label="Require locations"
    />
  );
}
